import { useApp } from '../App';
import BackButton from '../components/BackButton';
import { useState, useEffect } from 'react';
import api from '../api';
import Loading from '../components/Loading';
import CompanyGate from '../components/CompanyGate';
import { useI18n } from '../i18n/index.jsx';

function ApplicationsInner() {
  const { user, setPage } = useApp();
  const { t } = useI18n();
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [companies, setCompanies] = useState([]);
  const [form, setForm] = useState({ company_id: '', app_type: 'oswiadczenie', notes: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => { load(); }, []);

  async function load() {
    try {
      const [a, c] = await Promise.all([api.get('/applications'), api.get('/companies')]);
      setApps(a.data.filter(a => a.app_type !== 'karta_pobytu'));
      setCompanies(c.data);
      if (c.data.length && !form.company_id) setForm(f => ({ ...f, company_id: c.data[0].id }));
    } catch {}
    setLoading(false);
  }

  async function create() {
    setMsg('');
    try {
      await api.post('/applications', { ...form, company_id: Number(form.company_id) });
      setMsg('✅ ' + t('applications.created'));
      setShowForm(false);
      load();
    } catch (e) { setMsg('❌ ' + (e.response?.data?.detail || e.message)); }
  }

  async function submit(id) {
    try { await api.post(`/applications/${id}/submit`); load(); } catch {}
  }

  const typeLabels = { oswiadczenie: '📝 Oświadczenie', zezwolenie: '📜 Zezwolenie' };
  const statusLabels = {
    draft: '📝 ' + t('applications.status_draft'),
    submitted: '📤 ' + t('applications.status_submitted'),
    in_review: '🔍 ' + t('applications.status_in_review'),
    documents_required: '📎 ' + t('applications.status_documents_required'),
    approved: '✅ ' + t('applications.status_approved'),
    rejected: '❌ ' + t('applications.status_rejected'),
  };

  if (loading) return <Loading />;

  if (showForm) return (
    <div className="page">
      <BackButton />
      <h1>📋 {t('applications.new')}</h1>
      <div className="form">
        <div className="field"><label>{t('applications.type_label')}</label>
          <select value={form.app_type} onChange={e => setForm({ ...form, app_type: e.target.value })}>
            <option value="oswiadczenie">Oświadczenie o powierzeniu pracy</option>
            <option value="zezwolenie">Zezwolenie na pracę</option>
          </select></div>
        <div className="field"><label>{t('common.company')}</label>
          <select value={form.company_id} onChange={e => setForm({ ...form, company_id: e.target.value })}>
            {companies.map(c => <option key={c.id} value={c.id}>{c.short_name || c.name}</option>)}
          </select></div>
        <div className="field"><label>{t('applications.notes_label')}</label>
          <textarea value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} rows={3} /></div>
      </div>
      {msg && <div className="message">{msg}</div>}
      <div className="actions">
        <button className="btn btn-primary" onClick={create}>✅ {t('common.create')}</button>
        <button className="btn btn-secondary" onClick={() => setShowForm(false)}>{t('common.cancel')}</button>
      </div>
    </div>
  );

  return (
    <div className="page">
      <BackButton />
      <h1>📋 {t('applications.title')}</h1>
      <button className="btn btn-primary" onClick={() => setShowForm(true)}>+ {t('applications.new')}</button>
      {apps.length === 0 ? <div className="empty">{t('applications.no_apps')}</div> :
        <div className="list">
          {apps.map(a => (
            <div key={a.id} className="list-item">
              <div className="list-main">
                <div className="list-title">{typeLabels[a.app_type] || a.app_type}</div>
                <div className="list-sub">{a.created_at?.split('T')[0]} • {a.notes?.substring(0, 50) || ''}</div>
              </div>
              <div className="list-right">
                <div className={`status-badge status-${a.status}`}>{statusLabels[a.status] || a.status}</div>
                {a.status === 'draft' && <button className="btn btn-small" onClick={() => submit(a.id)}>📤</button>}
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}

export default function Applications() {
  return <CompanyGate requireWorkAuth><ApplicationsInner /></CompanyGate>;
}
